
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import { Controller } from "react-hook-form";
import { ClassNameMap } from '@material-ui/styles';
import KPILabel from './KPILabel';

interface PatientTransportKPIProps {
    parentClasses: ClassNameMap,
    StarIcon: any,
    control: any,
    isItVisible: boolean
}

const useStyles = makeStyles((theme) => ({
    kpiLabelText: {
        color: 'white',
        lineHeight: '40px'
    },
    kpiLabel: {
        height: 40,
        paddingLeft: 20,
        paddingRight: 20
    },
    rootGridHidden:{
       display: 'none'
    }
}));

const redAlert = '#E05151';
const yellowAlert = '#F4B827';

const PatientTransportKPI: React.FC<PatientTransportKPIProps> = ({
    parentClasses,
    StarIcon,
    control,
    isItVisible
}) => {
    const classes = useStyles();
    const rootClass = isItVisible?parentClasses.grid:classes.rootGridHidden;
    return (
        <>
            <Grid container item xs={12} spacing={3} style={{ marginTop: 20 }} className={rootClass}>
                <Grid item xs={12}>
                    <div className={parentClasses.textFieldLable}><StarIcon />Patient Transport KPI</div>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Transfers Per Day</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if below" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control}
                                as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="transfersPerDayYellowAlert"
                                defaultValue=''
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if below" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control}
                                as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="transfersPerDayRedAlert"
                                defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>% Multiload</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if below" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="percentMultiloadYellowAlert"
                                defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if below" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="percentMultiloadRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Transfers Per Hour</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if below" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="transfersPerHourYellowAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if below" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="transfersPerHourRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Km Per Transfer</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if above" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="kmPerTransferYellowAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if above" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="kmPerTransferRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default PatientTransportKPI;

